// Subcontractor / Tariff Management page and the tariff dialog. Excel and PDF stay Turkish.
const tariffs = {
  page: {
    title: 'Subcontractor / Tariff Management',
    subtitle: 'FTE and hourly tariffs per customer and project; amounts are value × unit price.',
  },
  yes: 'Yes',
  no: 'No',
  types: {
    hour: 'Hourly',
  },
  status: {
    active: 'Active',
    passive: 'Inactive',
  },
  common: {
    cancel: 'Cancel',
  },
  actions: {
    withoutTariffs: 'Projects Without Tariffs',
    withoutTariffsHint: 'Show projects that have no tariff yet',
    excel: 'Excel',
    excelHint: 'Download the listed tariffs as Excel',
    pdf: 'PDF',
    pdfHint: 'Download the listed tariffs as PDF',
    preparing: 'Preparing…',
    add: 'New Tariff',
  },
  stats: {
    total: 'Total Tariffs',
    totalShort: 'Total',
    active: 'Active Tariffs',
    activeShort: 'Active',
    inactive: 'Inactive Tariffs',
    inactiveShort: 'Inactive',
    withoutTariffs: 'Projects Without Tariffs',
    withoutTariffsShort: 'No tariff',
    share: '{{percent}}% of all tariffs',
  },
  toolbar: {
    search: 'Search customer, project, type, value or info…',
    searchShort: 'Search tariffs…',
    project: 'Filter by project',
    allProjects: 'All projects ({{count}})',
    clearProject: 'Clear the project filter',
    testProjects: 'Test projects',
    testProjectsShow: 'Include the tariffs of test projects',
    testProjectsHide: 'Hide the tariffs of test projects',
    totals: 'Total amount',
    totalsHint: 'Total amount of the listed tariffs per currency',
  },
  table: {
    listLabel: 'Tariff list',
    empty: 'No tariffs match the filters',
    rangeOf: 'of {{total}} tariffs',
    ofTotal: 'out of {{total}} in total',
    jump: 'Go to page',
    deletedProject: 'Deleted project',
    deletedProjectHint: 'The project of this tariff has been deleted',
  },
  columns: {
    customer: 'Customer',
    project: 'Project',
    type: 'Tariff Type',
    value: 'Tariff Value',
    price: 'Unit Price',
    amount: 'Amount (Value × Price)',
    currency: 'Currency',
    date: 'Date',
    subcontractor: 'Subcontractor',
    info: 'Info',
    status: 'Status',
  },
  panel: {
    label: 'Selected tariff',
    heading: 'Tariff',
    tariff: 'Tariff',
    edit: 'Edit',
    delete: 'Delete',
    subcontractor: 'Subcontractor: {{answer}}',
  },
  delete: {
    title: 'Delete tariff',
    message: 'The {{type}} {{value}} tariff ({{project}}) will be deleted permanently. Are you sure?',
    confirm: 'Delete',
  },
  withoutTariffs: {
    title: 'Projects Without Any Tariff ({{count}})',
    subtitle: 'Tap the button on a project to add its tariffs.',
    allDone: 'Every project has at least one tariff!',
    search: 'Search project or customer…',
    noMatch: 'No project matches the search.',
    add: 'Add Tariff',
  },
  modal: {
    titleAdd: 'Add New Tariffs',
    subtitleAdd: 'Create tariffs for one or more projects of a customer',
    titleEdit: 'Edit Tariff',
    choose: 'Please select',
    customer: 'Customer',
    customersLoading: 'Loading customers…',
    projects: 'Projects (multiple)',
    projectsLoading: 'Loading projects…',
    chooseCustomerFirst: 'Select a customer first',
    noProjects: 'No projects found for this customer',
    hasTariffs: 'Has tariffs',
    projectsSelected_one: '{{count}} project selected',
    projectsSelected_other: '{{count}} projects selected',
    currencyInfo: 'Exchange rate of the selected projects',
    currencyFixed: 'Fixed exchange rate ({{rate}})',
    currencyNotFixed: 'No fixed exchange rate',
    type: 'Tariff Type',
    currency: 'Currency',
    date: 'Date',
    subcontractor: 'Subcontractor?',
    info: 'Info',
    fteTitle: 'FTE Values',
    hourlyTitle: 'Hourly Rate',
    chooseTypeFirst: 'Select the tariff type first to enter values.',
    hourlyRate: 'Rate per Hour',
    raise: 'Raise Tariffs (%)',
    raisePlaceholder: 'E.g. 10',
    raiseHintHourly: 'Tap "Apply" to raise the current hourly rate by the given percentage.',
    raiseHintFte: 'Raises the prices of the selected FTE values by the given percentage.',
    apply: 'Apply',
    fteHintEdit: 'Tap "Remove" to take an existing FTE value off.',
    fteHintAdd: 'Select the FTE values you want to add.',
    defaultPrice: 'Default Price',
    defaultPricePlaceholder: 'Price for the selected FTE values',
    defaultPriceHint: 'Applied to every selected FTE value; each can be edited afterwards.',
    existing: 'Existing',
    selected: 'Selected',
    notSelected: 'Not selected',
    price: 'Price',
    priceFor: 'Price of FTE {{value}}',
    remove: 'Remove',
    removeHint: 'Remove this value',
    fteClickHint: 'Tap an FTE value to select or remove it.',
    existingTitle: 'Existing tariffs of the selected projects',
    existingLoading: 'Loading tariffs…',
    recordValue: 'Value: {{value}}',
    recordPrice: 'Price: {{price}}',
    recordCurrency: 'Currency: {{currency}}',
    recordDate: 'Date: {{date}}',
    noExistingForProject: 'No tariffs for this project yet (can be added)',
    noExisting: 'No existing tariffs for the selected projects',
    save: 'Save',
    update: 'Update',
    saving: 'Saving…',
  },
  toast: {
    projectsError: 'Projects could not be loaded',
    loadError: 'Tariffs could not be loaded',
    deleted: 'Tariff deleted',
    deleteError: 'The tariff could not be deleted',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
    nothingToExport: 'There are no tariffs to export.',
    excelDone: 'Excel file downloaded',
    excelError: 'The Excel file could not be created',
    pdfDone: 'PDF file downloaded',
    pdfError: 'The PDF file could not be created',
    customersError: 'Customers could not be loaded',
    existingError: 'Existing tariffs could not be loaded.',
    required: 'Please fill in all required fields',
    hourlyRequired: 'Please enter the hourly rate',
    fteRequired: 'Please select at least one FTE value',
    updated: 'Tariff updated',
    updatedCount_one: '{{count}} tariff updated',
    updatedCount_other: '{{count}} tariffs updated',
    createdCount_one: '{{count}} new tariff added',
    createdCount_other: '{{count}} new tariffs added',
    deactivatedCount_one: '{{count}} tariff set to inactive',
    deactivatedCount_other: '{{count}} tariffs set to inactive',
    skipped: 'These projects already have tariffs and were skipped: {{projects}}',
    nothingToAdd: 'There are no new tariffs to add',
    saveError: 'The tariffs could not be processed',
    percentRequired: 'Please enter a raise percentage',
    noPricedSelection: 'No selected tariff has a price',
    percentApplied: 'Selected tariffs raised by {{percent}}%',
    positivePercent: 'Please enter a positive raise percentage',
    hourlyFirst: 'Enter the hourly rate first',
    hourlyRaised: 'Hourly rate raised by {{percent}}%',
  },
};

export default tariffs;
